import { render, staticRenderFns } from "./ChatConversation.vue?vue&type=template&id=02f8dafe&"
import script from "./ChatConversation.vue?vue&type=script&lang=js&"
export * from "./ChatConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports